import React from "react";
import { Chip } from "@mui/material";
import { TextMidCut } from "../../../../../common/components";
import { isSegFeatureEnabled, SegFlags, translate } from "../../../../../common/providers";
import styles from "./DocumentCenterPanelTitle.module.css";

const DocumentCenterPanelTitle = React.forwardRef(({ docType, title }) => (
	<span className={styles.title}>
		<TextMidCut
			showWhenOverflow
			tooltip
			autoTranslate="no"
			className={styles.label__text}
			data-is-deliverable={docType === "DELIVERABLE"}
			text={title}
		/>
		{isSegFeatureEnabled(SegFlags.DOC_TYPE_DELIVERABLE) && docType === "DELIVERABLE" && (
			<Chip
				className={styles.label__chip}
				label={translate("document-center.table.actions.type.deliverable")}
				size="small"
			/>
		)}
	</span>
));
export default DocumentCenterPanelTitle;
